import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  options: [],
  fields: [
    { key: 'no', label: 'no'},
    { key: 'name', label: 'type', sortable: true },
    { key: 'is_have_formula', label: 'is have formula', sortable: true },
    { key: 'created_at', label: 'Created At', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/device-types?status=AC'}
    useIPA.get(param).then(response => {
      const device = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...device})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/device-types/' + id}
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        // default_unit: formData.text_2,
        is_have_formula: formData.checkbox_1,
        description: formData.textarea_1,
        status: "AC"
			}
      const param = { rawData: rawData, url: 'internal/master/device-types', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'data-device-type' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/device-types/', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, device) {
    device.rows.forEach(function (element,index) {
      element.no = index+1
    })
    state.items = device.rows
    state.totalRows = device.rows.length
    state.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') { 
          option['value'] = device.rows[i][key] 
        } else if (key === 'name') { 
          option['title'] = device.rows[i][key] 
        } else if (key === 'id') { 
          option['oid'] = device.rows[i][key] 
        } 
      }
      state.options.push(Object.assign({}, option))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
